import { parsePhoneNumber } from 'libphonenumber-js';

/**
 * Formats a raw phone number string for display only.
 *
 * Stored values stay in their raw form (e.g. E.164 `+4523713946`); this helper
 * produces a human-friendly representation by grouping the country code and the
 * national number (e.g. `+45 23 71 39 46`). Country codes vary in length, so we
 * rely on libphonenumber-js to split and group correctly per region.
 *
 * If the value can't be parsed (partial input, non-phone text), the original
 * string is returned unchanged so the display never loses information.
 */
export function formatPhoneNumber(value: string): string {
  if (!value) return value;

  try {
    const parsed = parsePhoneNumber(value.trim());
    if (parsed?.isValid()) {
      return parsed.formatInternational();
    }
  } catch {
    // Fall through to the raw value below.
  }

  return value;
}
